<template>
	<div class="header">
	  <div class="header-top">
		  <a href=""><img class="header-top-logo" :src="logoUrl"></a>
		  <img class="header-top-phone" src="/src/assets/images/index_06.png">
	  </div>
	    <div class="header-bott">
		<ul class="header-bott-box">
			<li v-for="(item,index) in classData" :key="item.id"><a :class="item.id== cid?'header-bott-act':''" :href="item.linkurl">{{item.classname}}</a></li>
		</ul>	
	  </div>
	</div>
</template>

<script>
import { listGrave,getBanner,getIndexData } from '../api/index'

export default {
  name: 'web-header',
  props: {
 //    msg: String,
	// classdata:Array,
	cid:Number,
	// logourl:String,
  },
  data () {
      return {
          bannerData: [],
  		  graveData:[],
  		  gardenData:[],
  		  recomNewsData:[],
  		  classData:[],
  		   map: Object,
  		   center: {
  			   lng: 109.008296,
  			   lat: 32.765564
  		  },
  		  zoom: 11,
  		  points: [],
  		  // cid:1,
  		  idx_desc:'',
  		  desc_pic:[],
  		  site_idx_grave_words_pic:'',
  		  logoUrl:'',
  		  record_No:'',
		  // logourl:String,
  		  copyright:'',
  		  idx_bott_wxqrcode:'',
  		  idx_bott_logo:'',
      }
  },
  mounted() {
      const _this = this
	  getIndexData().then(res => {
	  	console.log(res)
	  	if(res.status==200){
	  		console.log(111)
	  		_this.bannerData = res.data.banner;
			_this.gardenData = res.data.graden_show.list;
			_this.graveData = res.data.grave_show;
			_this.recomNewsData = res.data.recom_news || {};
			_this.classData = res.data.siteclass.list;
			_this.idx_desc = res.data.idx_desc;
			_this.desc_pic = res.data.desc_pic;
			_this.site_idx_grave_words_pic = res.data.site_idx_grave_words_pic; 
			_this.logoUrl = res.data.logoUrl; 
			_this.record_No = res.data.record_No; 
			_this.copyright = res.data.copyright; 
			_this.idx_bott_logo = res.data.idx_bott_logo; 
			_this.idx_bott_wxqrcode = res.data.idx_bott_wxqrcode; 
	  	}
	  }).catch(res => {
	  	_this.$notify({
	  	  title: 'It works!',
	  	  type: 'success',
	  	  message: res,
	  	  duration: 5000
	  	})
	  })   
  }
}

</script>
<style>
	@import url("/src/assets/style/header.css");
</style>


// WEBPACK FOOTER //
// src/components/Header.vue